/* eslint-disable no-magic-numbers */

import { getConfigValue, getProjectIdFromUrl } from './index.utils';

export const BASE_API_URL = getConfigValue('BASE_API_URL');
export const BASE_MAP_IMAGES_URL = getConfigValue('BASE_MAP_IMAGES_URL');
export const BASE_NEW_API_URL = getConfigValue('BASE_NEW_API_URL');
export const DEFAULT_PROJECT_ID = getConfigValue('DEFAULT_PROJECT_ID');
export const PROJECT_ID = getProjectIdFromUrl() || DEFAULT_PROJECT_ID;
export const ZOD_SEED = parseInt(process.env.ZOD_SEED || '123', 10);
export const MODEL_ELEMENT = 'modelElement';
export const DRUGS_CHEMICALS = ['drugs', 'chemicals'];
export const MINERVA_WEBSITE_URL = 'https://minerva.pages.uni.lu/';
export const MINERVA_REPOSITORY_URL =
  'https://gitlab.com/uniluxembourg/lcsb/BioCore/minerva/frontend';
/**
 * Minerva is licensed under the AGPL-3.0, whose section 13 requires that users
 * interacting with the application over a network are offered access to the
 * Corresponding Source of the version they are using. The version is reported by
 * the backend configuration, so link to its tag when it is known and fall back to
 * the repository root before the configuration has loaded.
 */
export const getSourceCodeUrl = (version?: string): string =>
  version ? `${MINERVA_REPOSITORY_URL}/-/tree/v${version}` : MINERVA_REPOSITORY_URL;
